import React, { useEffect, useState } from "react"
import { graphql } from "gatsby"

import Header from "../components/Header"
import PymesSection from "../components/PymesSection"
import SideBar from "../components/SideBar"

const randomizeArray = array => {
  const filterArray = [...array]

  const randomArray = []

  while (filterArray.length !== 0) {
    let randomIndex = Math.floor(Math.random() * filterArray.length)
    randomArray.push(filterArray[randomIndex])
    filterArray.splice(randomIndex, 1)
  }
  return randomArray
}

export default function Home({ data, pageContext }) {
  const [rockstars, setRockstars] = useState([])
  const [startups, setStartups] = useState([])
  const [free, setFree] = useState([])

  useEffect(() => {
    const groupRockstars = data.allPymesJson.group.filter(
      g => g.fieldValue === "rockstar"
    )

    const groupStartups = data.allPymesJson.group.filter(
      g => g.fieldValue === "startup"
    )
    const groupFree = data.allPymesJson.group.filter(
      g => g.fieldValue === "free" || g.fieldValue === "pyme"
    )

    const groupPyme = data.allPymesJson.group.filter(
      g => g.fieldValue === "pyme"
    )

    let pymeLevel = []

    if (groupRockstars && groupRockstars[0]) {
      setRockstars(randomizeArray(groupRockstars[0].edges))
    }
    if (groupStartups && groupStartups[0]) {
      setStartups(randomizeArray(groupStartups[0].edges))
    }
    if (groupPyme && groupPyme[0]) {
      pymeLevel = [...randomizeArray(groupPyme[0].edges)]
    }
    if (groupFree && groupFree[0]) {
      setFree([...pymeLevel, ...randomizeArray(groupFree[0].edges)])
    }
  }, [data.allPymesJson.group])

  return (
    <main id="maincontent">
      <Header showSearch={false} />
      <div className="max-w-7xl mx-auto grid grid-cols-12 gap-8 mt-10">
        <div className="col-span-2">
          <SideBar
            categories={data.categories.group}
            regions={(data.regions && data.regions.group) || []}
            showSection={
              pageContext.category === "Servicio" ? "" : pageContext.parent
            }
          />
        </div>
        <div className="col-span-10">
          <h2 className="text-xl mb-6 ml-6">{pageContext.category}</h2>
          {rockstars.length > 0 && <PymesSection pymes={rockstars} />}
          {startups.length > 0 && <PymesSection pymes={startups} />}
          {free.length > 0 && <PymesSection pymes={free} />}
        </div>
      </div>
    </main>
  )
}

export const query = graphql`
  query CategoryGroupQuery($category: String) {
    allPymesJson(filter: { category: { eq: $category } }) {
      group(field: plan) {
        fieldValue
        totalCount
        edges {
          node {
            id
            name
            url
            logo
            description
            category
            comuna
            region
            tags
          }
        }
      }
    }
    categories: allPymesJson(filter: { name: { ne: "" } }) {
      group(field: category) {
        fieldValue
        totalCount
      }
    }
    regions: allPymesJson(filter: { name: { ne: "" } }) {
      group(field: region) {
        fieldValue
        totalCount
      }
    }
  }
`
